import Api from "../../../axios";
import { callLoader } from "../../../common/actions/app";

let ACTION_CHECK_LIST = {
    type: 'CHECK_LIST',
    payload: {
        rows: [],
        total: 0,
        pagination: [],
    },
};

let callCheckListGet = (filter = {}, pg = 1) => (dispatch) => {
    dispatch(callLoader(true))
    filter.pg = pg;
    Api.get('/checks?' + (new URLSearchParams(filter)).toString()).then((data) => {
        dispatch(callLoader(false))
        if (!data)
            return

        ACTION_CHECK_LIST.payload.rows = data.rows
        ACTION_CHECK_LIST.payload.total = data.total
        ACTION_CHECK_LIST.payload.pagination = data.pagination
        dispatch(ACTION_CHECK_LIST)
    })
}

export { callCheckListGet, ACTION_CHECK_LIST }